import { isUHandleLengthWarningLayoutCode } from "entities/configurator/model/layoutMeta";
import { exceedsMaxUHandleBeamGap, isUHandleCode } from "./doorHandleProfiles";
import type { HandleRepairReason } from "./handlePolicy";

export type HandleRepairNotification = {
  toastId: string;
  message: string;
};

const beamGapInvalidHandleRepairNotification = {
  toastId: "handle-height-reset",
  message:
    "De geselecteerde U-greep is niet beschikbaar bij deze hoogte. Daarom hebben wij automatisch een passende greep geselecteerd.",
} as const satisfies HandleRepairNotification;

export const uHandleLengthWarningNotification = {
  toastId: "u-handle-length-warning",
  message:
    "Let op: de maximale lengte van de U-greep is 2100 mm. Bij hogere deuren wordt het ontwerp hierop aangepast.",
} as const satisfies HandleRepairNotification;

/**
 * On the layouts flagged with `uHandleLengthWarning` a U-handle stays
 * selectable past the max beam gap, so the customer is warned instead.
 */
export const shouldShowUHandleLengthWarning = ({
  anchorBeamGap,
  handleCode,
  layoutCode,
}: {
  anchorBeamGap: number | null | undefined;
  handleCode: string | null | undefined;
  layoutCode: string | null | undefined;
}): boolean =>
  isUHandleLengthWarningLayoutCode(layoutCode) &&
  isUHandleCode(handleCode) &&
  exceedsMaxUHandleBeamGap(anchorBeamGap);

export const getHandleRepairNotification = (
  reason: HandleRepairReason,
): HandleRepairNotification | null => {
  switch (reason) {
    case "beam-gap-invalid":
      return beamGapInvalidHandleRepairNotification;
    case "policy-invalid":
      return null;
  }
};
